export default "__VITE_ASSET__CiBitW5___"